export default (el: HTMLAnchorElement): string => {
  return el.getAttribute('data-url') || el.href || '';
};
